import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CheckOTPCode_Request } from '../models/CheckOTPCode_Request.model';
import { GetPhone_Request } from '../models/GetPhone_Request.model';
import { SendOTPCode_Request } from '../models/SendOTPCode_Request.model';
import { NewFormOTP_Request } from '../models/NewFormOTP_Request.model';

import { BehaviorSubject } from 'rxjs';

@Injectable()
export class OtpService {
  apiUri: string = environment.apiUri + "/otp";
  private otpStatus: BehaviorSubject<string> = new BehaviorSubject("");
  isNewForm: boolean = false;
  phoneOk: boolean = false;
  getCode: boolean = false;
  confirmCode: boolean = false;
  hasLoggedInAdvisor: boolean = false;

  constructor(
    private http: HttpClient) { }


  getOtpStatus(){
    return this.otpStatus;
  }

  nextStatus(text) {
    this.otpStatus.next(text);
  }

  getPhones$(req: GetPhone_Request) {
    const url = `${this.apiUri}/getPhone`;  
    return this.http.post<any>(url, req);
  }

  getConsulantPhone$(req: GetPhone_Request) {
    const url = `${this.apiUri}/getConsulantPhone`;  
    return this.http.post<any>(url, req);
  }

  getSmsCode$(req: SendOTPCode_Request) {
    const url = `${this.apiUri}/sendOTPCode`;
    return this.http.post<any>(url, req);
  }

  getIvrCode$(req: SendOTPCode_Request) {
    const url = `${this.apiUri}/sendOTPVoiceIVR`;
    return this.http.post<any>(url, req);
  }

  confirmCode$(req: CheckOTPCode_Request) {
    const url = `${this.apiUri}/confirmOTPCode`;
    return this.http.post<any>(url, req);
  }
  newFormOTP$(req: NewFormOTP_Request) {
    const url = `${this.apiUri}/newFormOTP`;
    return this.http.post<any>(url, req);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/otp.service.ts